import { forwardRef } from 'react';
import DurationField from "../../../Form/DurationField/DurationField";
import { convertToUnixTimestamp } from "../../../utils/Dates";
import cn from "../../../../utils/cn";
import { jsx as _jsx } from "react/jsx-runtime";
const FilterDuration = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    id = '',
    label = 'Filter by date range',
    className = '',
    disabled = false,
    hideLabel = true,
    buttonLabel = 'Filter by date range',
    buttonClassName = '',
    labelClassName = '',
    hint = '',
    inline = false,
    name = '',
    placeholder = '',
    required = false,
    style = {
      container: {},
      dropdown: {},
      label: {},
      input: {},
      hint: {},
      error: {}
    },
    dateFormat = 'MM/DD/YYYY',
    valueFormat = convertToUnixTimestamp,
    isUtc = true,
    maxDate = null,
    minDate = null,
    shouldDisableDate = () => false,
    separator = '-',
    startField = {},
    endField = {},
    startFieldPath = 'startField',
    endFieldPath = 'endField',
    clearable = true,
    parentComponent = 'FilterDuration',
    onChange = null,
    onBlur = null,
    onFocus = null,
    customErrorMessage = ''
  } = _ref;
  const buttonClass = cn('normal-case text-text-blue text-left pl-3', buttonClassName);
  return /*#__PURE__*/_jsx(DurationField, {
    id: id,
    label: label,
    className: className,
    disabled: disabled,
    hideLabel: hideLabel,
    buttonLabel: buttonLabel,
    buttonClassName: buttonClass,
    hint: hint,
    inline: inline,
    labelClassName: labelClassName,
    name: name,
    placeholder: placeholder,
    required: required,
    style: style,
    dateFormat: dateFormat,
    valueFormat: valueFormat,
    isUtc: isUtc,
    maxDate: maxDate,
    minDate: minDate,
    shouldDisableDate: shouldDisableDate,
    separator: separator,
    startField: startField,
    endField: endField,
    startFieldPath: startFieldPath,
    endFieldPath: endFieldPath,
    ref: ref,
    clearable: clearable,
    parentComponent: parentComponent,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    customErrorMessage: customErrorMessage
  });
});
FilterDuration.displayName = 'FilterDuration';
export default FilterDuration;
//# sourceMappingURL=FilterDuration.js.map